<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Features',

    metaInfo: { title: 'Features' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'about-our-product',
        'theme-features',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'features',
      },
    },
  }
</script>
